import React, { useRef , useState} from 'react'
import { Upload, X } from 'lucide-react'
import { LoaderNew } from '../../components/LoaderNew';
import { envVariables } from '../../utils/envVariables/envVariables';

export const CargaMasiva = ({setCargaMasiva, typePromotion, idPromocion, promotion}) => {
	const [statusButton, setStatusButton] = useState("Cargar Archivo")
	const [loader, setLoader] = useState(false)
	const [erroresValidacion, setErroresValidacion] = useState(null)
	const fileInput = useRef(null);
	const templateType = String(typePromotion).toUpperCase() === 'SELL-IN' ? 'sellin' : 'sellout'

	console.log("INFO DE PROMOTION ")
	console.log(promotion)

	const confirmarEnvio = () => {
		const myHeaders = new Headers();
		myHeaders.append("Authorization", "Bearer "+localStorage.getItem('token'));
		fetch(envVariables.baseUrl+'/promotion/bulk/create', {
			method: 'POST',
			headers: myHeaders,
		})
		.then(response => {
			console.log(response)
			window.location.reload()
		})
		.catch(error => {
			console.error('Error:', error);
			alert("Error "+error)
			setStatusButton("Confirmar Envío")
			setLoader(false)
		});
		setLoader(false)
	}

	const enviarArchivo = () => {
        const file = fileInput.current.files[0];
		const myHeaders = new Headers();
		myHeaders.append("Authorization", "Bearer "+localStorage.getItem('token'));
        const formData = new FormData();
        formData.append('file', file);
		formData.append('tipo_promocion', typePromotion);
		formData.append("nombre_cadena", String(promotion.data_promocion.nombre_cadena).toUpperCase());
		formData.append("id_promocion", idPromocion);
        fetch(envVariables.baseUrl+'/promotion/bulk/validate', {
            method: 'POST',
			headers: myHeaders,
            body: formData
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Error en la solicitud');
            }
            return response.json();
        })
        .then(data => {
            // Manejar la respuesta del servicio si es necesario
            console.log('Respuesta del servicio:', data);
			if(data.error_messages){
				if(data.error_messages.length > 0){
					let errores = ""
					let countErrores = 0
					data.error_messages.map((error) => {
						if(error.total_errores > 0){
							countErrores += 1
						}
						errores += "- ERROR: "+error.codigo_producto+" con "+error.total_errores+" errores \n"+error.msg_error_fechas_sellin+" \n"+error.msg_error_fechas_sellout+" \n"
						return error
					})
					if(countErrores === 0){
						errores = "Todas las filas están correctas, ¿Desea confirmar el envío?"
						setStatusButton("Confirmar Envío")
					}else{
						setStatusButton("Cargar Archivo")
					}
					setErroresValidacion(errores)
					
				}else{
					setErroresValidacion(null)
					const validacion = "Todas las filas están correctas, ¿Desea confirmar el envío?"
					setErroresValidacion(validacion)
					setStatusButton("Confirmar Envío")
				}
			}
			setLoader(false)
        })
        .catch(error => {
            console.error('Error:', error);
			alert("Error "+error)
			setLoader(false)
			setErroresValidacion("Error en la carga masiva, intente más tarde.")
			setStatusButton("Cargar Archivo")
        });
		setLoader(false)
    };

	const descargarTemplate = async () => {
		try {
			const response = await fetch(
				`${envVariables.baseUrl}/promotion/bulk/template/${templateType}`,
				{
					method: 'GET',
					headers: {
						Authorization: `Bearer ${localStorage.getItem('token')}`,
					},
				}
			)

			if (!response.ok) {
				throw new Error('No se pudo descargar el template.')
			}

			const blob = await response.blob()
			const url = window.URL.createObjectURL(blob)
			const link = document.createElement('a')
			link.href = url
			link.download = `template_carga_masiva_${templateType}.xlsx`
			document.body.appendChild(link)
			link.click()
			link.remove()
			window.URL.revokeObjectURL(url)
		} catch (error) {
			console.error('Error al descargar template:', error)
			alert(error?.message || 'No se pudo descargar el template.')
		}
	}

	return (
		<>
			<span
				className='black_bg popup'
				onClick={(e) => {
					setCargaMasiva(null)
				}}
			></span>
			<div className='LogoutPopupNew InicioPop'>
				<span style={{width:44,height:44,minWidth:44,minHeight:44,flexShrink:0,borderRadius:'50%',background:'#F0F4FC',display:'inline-flex',alignItems:'center',justifyContent:'center'}}>
					<Upload size={22} color='#3676F5' />
				</span>

				<h1>Carga Masiva tipo: {typePromotion}</h1>
				<p id={"erroresValidacion"}>Debes utilizar el siguiente formato para realizar la carga masiva:
				<button type='button' className='bulk-template-link' onClick={descargarTemplate}>template</button>
                <input type='file' id='file' name='file' accept='.csv, .xlsx, .xls' ref={fileInput}/>
				{loader && <LoaderNew notdo={true}/>}
				{erroresValidacion && erroresValidacion}
                </p>

                

				<div className='button_wrapper'>
					<button
						onClick={(e) => {
							if(statusButton !== 'Confirmar Envío'){
								enviarArchivo()
								// setCargaMasiva(null)
								setStatusButton("Cargando...")
								setLoader(true)
							}else{
								confirmarEnvio()
								setStatusButton("Enviando...")
								setLoader(true)
							}
							
						}}
					>
						{statusButton}
					</button>
				</div>

				<X
					onClick={(e) => setCargaMasiva(false)}
					size={10}
					color='#ADADAD'
					style={{cursor: 'pointer'}}
				/>
			</div>
		</>
	)
}
